import React from "react";
import "../assets/css/contact.scss";
import "../App.css";

const contactLinks = [
  {
    label: "Email",
    href: "mailto:derryckdxd@gmail.com",
    icon: "fa fa-envelope",
  },
  {
    label: "GitHub",
    href: "https://github.com/EnigmaTechx",
    icon: "fa fa-github",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/derryckniinoidowuona",
    icon: "fa fa-linkedin",
  },
];

const Contact = () => {
  return (
    <section id="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Get In Touch</span>
          <h1 className="section-title">Contact</h1>
          <p className="section-desc">
            Have a project in mind, or just want to talk shop? My inbox is
            always open — I'll get back to you as soon as I can.
          </p>
        </div>

        <div className="contact-grid">
          {contactLinks.map((item) => (
            <a
              href={item.href}
              target={item.label !== "Email" ? "_blank" : undefined}
              rel="noreferrer"
              className="contact-card glass-panel"
              key={item.label}
            >
              <span className="contact-icon">
                <i className={item.icon}></i>
              </span>
              <span className="contact-label">{item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
